module.exports = __webpack_public_path__ + "img/InviteFriends.dcbf6948.svg";